import { Team } from "@/teams";
import { AccountType, User, UserGroup } from "@infoland/iprova-api";
import { PropOptions } from "vue";

export enum SystemItem {
    administrator = "administrator",
    anonymous = "anonymous",
    allLoggedInUsers = "allLoggedInUsers",
    allUsers = "allUsers",
    managers = "managers"
}

export type UserItem = {
    assigneeId: string;
    name: string;
    type: UserSelectionType;
    data?: User | UserGroup | Team;
};

export const props = {
    allowedTypes: {
        required: true
    } as PropOptions<UserSelectionType[]>,
    allowedUserIDs: Array as () => string[],
    allowedUserGroupIDs: Array as () => string[],
    allowedTeamIDs: Array as () => string[],
    allTeamMembersOption: {
        // decides whether team toggle buttons are shown
        type: Boolean,
        default: false
    },
    multiple: {
        type: Boolean,
        default: false
    },
    allowedSystemItems: { default: () => [] as SystemItem[] },
    excludedIDs: { default: () => [] as string[] },
    requireEmail: { default: () => "no", type: String as () => "yes" | "no" },
    userAccountTypeFilter: String as () => AccountType
};

export type UserSelectionType = "user" | "usergroup" | "team" | "unknown";

export interface UserSelectionItem<T extends User | UserGroup | Team = User | UserGroup | Team> {
    item_id: string;
    name?: string;
    type: UserSelectionType;
    data: T;
}

export interface ItemPoolResult {
    items: UserSelectionItem[];
    moreItemsAvailable: boolean;
    containsUsers: boolean;
    containsUserGroups: boolean;
    containsTeams: boolean;
}

export type UserSelectorOptions = {
    /** The types of item allowed in the user selector */
    allowedTypes: UserSelectionType[];
    /** The user ids that are allowed to be selected */
    allowedUserIDs?: string[];
    /** The user group ids that are allowed to be selected */
    allowedUserGroupIDs?: string[];
    /** The team ids that are allowed to be selected */
    allowedTeamIDs?: string[];
    /** Whether multiple items can be selected at once */
    multiple?: boolean;
    /** The system items that will show up in the dialog */
    allowedSystemItems?: SystemItem[];
    /** ids to exclude from the list of items */
    excludedIDs?: string[];
    /** Whether to exclude inactive accounts */
    excludeInactive?: boolean;
    /** Whether e-mail address is required for users shown in the user selector */
    requireEmail?: "yes" | "no";
    /** Filter for personal/group accounts */
    userAccountType?: AccountType;
    /** whether selection is disabled  */
    disabled?: boolean;
    /** the reason why selection is disabled */
    disabledReason?: string;
};
